import { useEffect } from 'react';

// Scrolls to top on route change
export const ScrollToTop = ({ pathname }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};
